<template>
  <div class="expansion-panel-content-container">
    <div class="title-container">
      <font-awesome-icon :icon="['fa', 'anchor']" style="font-size: 1.2rem" />
      <span class="panel-title">Arrival settings </span>
    </div>
    <v-switch
      class="mb-2"
      v-model="justInTimeArrivalModel"
      :flat="true"
      label="Just in time arrival"
      color="primary"
      dark
    />
    <div v-if="justInTimeArrivalModel" class="arrival-settings-container">
      <v-dialog
        ref="arrivalDateDialog"
        v-model="arrivalDateModal"
        persistent
        width="290px"
        :return-value.sync="arrivalDateModel"
      >
        <template v-slot:activator="{ on, attrs }">
          <ThemedTextField
            v-model="arrivalDateModel"
            label="Arrival date"
            append-icon="mdi-calendar"
            outlined
            readonly
            :rules="[justInTimeArrivalDateRule]"
            persistent-placeholder
            v-bind="attrs"
            v-on="on"
          />
        </template>
        <v-date-picker v-model="arrivalDateModel" scrollable>
          <v-spacer></v-spacer>
          <v-btn text color="primary" @click="arrivalDateModal = false">
            Cancel
          </v-btn>
          <v-btn
            text
            color="primary"
            @click="$refs.arrivalDateDialog.save(arrivalDateModel)"
          >
            OK
          </v-btn>
        </v-date-picker>
      </v-dialog>
      <v-dialog
        ref="arrivalTimeDialog"
        v-model="arrivalTimeModal"
        :return-value.sync="arrivalTimeModel"
        persistent
        width="290px"
      >
        <template v-slot:activator="{ on, attrs }">
          <ThemedTextField
            v-model="arrivalTimeModel"
            label="Arrival time"
            append-icon="mdi-clock-time-four-outline"
            outlined
            persistent-placeholder
            readonly
            :rules="[justInTimeArrivalTimeRule]"
            v-bind="attrs"
            v-on="on"
          />
        </template>
        <v-time-picker
          v-if="arrivalTimeModal"
          v-model="arrivalTimeModel"
          full-width
        >
          <v-spacer></v-spacer>
          <v-btn text color="primary" @click="arrivalTimeModal = false">
            Cancel
          </v-btn>
          <v-btn
            text
            color="primary"
            @click="$refs.arrivalTimeDialog.save(arrivalTimeModel)"
          >
            OK
          </v-btn>
        </v-time-picker>
      </v-dialog>
    </div>
    <v-switch
      class="pa-0"
      v-model="enforceArrivalWindowModel"
      :flat="true"
      label="Arrival window"
      color="primary"
      dark
    />
    <div v-if="enforceArrivalWindowModel" class="arrival-settings-container">
      <v-dialog
        ref="earliestDateDialog"
        v-model="earliestDateModal"
        persistent
        width="290px"
        :return-value.sync="earliestDateModel"
      >
        <template v-slot:activator="{ on, attrs }">
          <ThemedTextField
            v-model="earliestDateModel"
            label="Earliest date"
            append-icon="mdi-calendar"
            outlined
            readonly
            :rules="[arrivalWindowEarliestDateRule]"
            persistent-placeholder
            v-bind="attrs"
            v-on="on"
          />
        </template>
        <v-date-picker v-model="earliestDateModel" scrollable>
          <v-spacer></v-spacer>
          <v-btn text color="primary" @click="earliestDateModal = false">
            Cancel
          </v-btn>
          <v-btn
            text
            color="primary"
            @click="$refs.earliestDateDialog.save(earliestDateModel)"
          >
            OK
          </v-btn>
        </v-date-picker>
      </v-dialog>
      <v-dialog
        ref="latestDateDialog"
        v-model="latestDateModal"
        persistent
        width="290px"
        :return-value.sync="latestDateModel"
      >
        <template v-slot:activator="{ on, attrs }">
          <ThemedTextField
            v-model="latestDateModel"
            label="Latest date"
            append-icon="mdi-calendar"
            outlined
            readonly
            :rules="[arrivalWindowLatestDateRule]"
            persistent-placeholder
            v-bind="attrs"
            v-on="on"
          />
        </template>
        <v-date-picker v-model="latestDateModel" scrollable>
          <v-spacer></v-spacer>
          <v-btn text color="primary" @click="latestDateModal = false">
            Cancel
          </v-btn>
          <v-btn
            text
            color="primary"
            @click="$refs.latestDateDialog.save(latestDateModel)"
          >
            OK
          </v-btn>
        </v-date-picker>
      </v-dialog>
      <v-dialog
        ref="earliestTimeDialog"
        v-model="earliestTimeModal"
        :return-value.sync="earliestTimeModel"
        persistent
        width="290px"
      >
        <template v-slot:activator="{ on, attrs }">
          <ThemedTextField
            v-model="earliestTimeModel"
            label="Earliest time"
            append-icon="mdi-clock-time-four-outline"
            outlined
            persistent-placeholder
            readonly
            :rules="[arrivalWindowEarliestTimeRule]"
            v-bind="attrs"
            v-on="on"
          />
        </template>
        <v-time-picker
          v-if="earliestTimeModal"
          v-model="earliestTimeModel"
          full-width
        >
          <v-spacer></v-spacer>
          <v-btn text color="primary" @click="earliestTimeModal = false">
            Cancel
          </v-btn>
          <v-btn
            text
            color="primary"
            @click="$refs.earliestTimeDialog.save(earliestTimeModel)"
          >
            OK
          </v-btn>
        </v-time-picker>
      </v-dialog>
      <v-dialog
        ref="latestTimeDialog"
        v-model="latestTimeModal"
        :return-value.sync="latestTimeModel"
        persistent
        width="290px"
      >
        <template v-slot:activator="{ on, attrs }">
          <ThemedTextField
            v-model="latestTimeModel"
            label="Latest time"
            append-icon="mdi-clock-time-four-outline"
            outlined
            persistent-placeholder
            :rules="[arrivalWindowLatestTimeRule]"
            readonly
            v-bind="attrs"
            v-on="on"
          />
        </template>
        <v-time-picker
          v-if="latestTimeModal"
          v-model="latestTimeModel"
          full-width
        >
          <v-spacer></v-spacer>
          <v-btn text color="primary" @click="latestTimeModal = false">
            Cancel
          </v-btn>
          <v-btn
            text
            color="primary"
            @click="$refs.latestTimeDialog.save(latestTimeModel)"
          >
            OK
          </v-btn>
        </v-time-picker>
      </v-dialog>
    </div>
  </div>
</template>
    
    <script>
import { mapState } from "vuex";
import ThemedTextField from "@/core/ThemedTextField.vue";
export default {
  name: "SetArrivalOptionsComponent",
  components: {
    ThemedTextField,
  },
  data: function () {
    return {
      arrivalDateModal: false,
      arrivalTimeModal: false,
      earliestDateModal: false,
      earliestTimeModal: false,
      latestDateModal: false,
      latestTimeModal: false,
      openedPanel: [],
      justInTimeArrivalTimeRule: () => {
        if (this.justInTimeArrival) {
          return this.arrivalTime != null || "Select arrival time";
        }
      },
      justInTimeArrivalDateRule: () => {
        if (this.justInTimeArrival) {
          return this.arrivalDate != null || "Select arrival date";
        }
      },
      arrivalWindowEarliestTimeRule: () => {
        if (this.enforceArrivalWindow) {
          return this.earliestTime != null || "Select earliest time";
        }
      },
      arrivalWindowEarliestDateRule: () => {
        if (this.enforceArrivalWindow) {
          return this.earliestDate != null || "Select earliest date";
        }
      },
      arrivalWindowLatestTimeRule: () => {
        if (this.enforceArrivalWindow) {
          return this.latestTime != null || "Select latest time";
        }
      },
      arrivalWindowLatestDateRule: () => {
        if (this.enforceArrivalWindow) {
          return this.latestDate != null || "Select latest date";
        }
      },
    };
  },
  computed: {
    ...mapState("weatherRouting/formModule", [
      "justInTimeArrival",
      "enforceArrivalWindow",
      "arrivalDate",
      "arrivalTime",
      "earliestDate",
      "earliestTime",
      "latestDate",
      "latestTime",
    ]),
    justInTimeArrivalModel: {
      get() {
        return this.justInTimeArrival;
      },
      set(value) {
        this.$store.commit(
          "weatherRouting/formModule/SET_JUST_IN_TIME_ARRIVAL",
          value,
          { root: true }
        );
      },
    },
    enforceArrivalWindowModel: {
      get() {
        return this.enforceArrivalWindow;
      },
      set(value) {
        this.$store.commit(
          "weatherRouting/formModule/SET_ENFORCE_ARRIVAL_WINDOW",
          value,
          { root: true }
        );
      },
    },
    arrivalDateModel: {
      get() {
        return this.arrivalDate;
      },
      set(value) {
        this.$store.commit(
          "weatherRouting/formModule/SET_ARRIVAL_DATE",
          value,
          { root: true }
        );
      },
    },
    arrivalTimeModel: {
      get() {
        return this.arrivalTime;
      },
      set(value) {
        this.$store.commit(
          "weatherRouting/formModule/SET_ARRIVAL_TIME",
          value,
          { root: true }
        );
      },
    },
    earliestDateModel: {
      get() {
        return this.earliestDate;
      },
      set(value) {
        this.$store.commit(
          "weatherRouting/formModule/SET_EARLIEST_DATE",
          value,
          { root: true }
        );
      },
    },
    earliestTimeModel: {
      get() {
        return this.earliestTime;
      },
      set(value) {
        this.$store.commit(
          "weatherRouting/formModule/SET_EARLIST_TIME",
          value,
          { root: true }
        );
      },
    },
    latestDateModel: {
      get() {
        return this.latestDate;
      },
      set(value) {
        this.$store.commit("weatherRouting/formModule/SET_LATEST_DATE", value, {
          root: true,
        });
      },
    },
    latestTimeModel: {
      get() {
        return this.latestTime;
      },
      set(value) {
        this.$store.commit("weatherRouting/formModule/SET_LATEST_TIME", value, {
          root: true,
        });
      },
    },
    isPanelOpen() {
      return this.openedPanel.length != 0;
    },
  },
};
</script>
    
<style scoped>
.expansion-panel-content-container {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 5px;
}

.title-container {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 10px;
  color: var(--color-text);
}

.arrival-settings-container {
  display: flex;
  flex-wrap: wrap;
  gap: 0px 10px;
  width: 100%;
}
</style>